(function () {
    'use strict';

    angular
        .module('bcmModule')
        .directive('biaResponsibility', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);

        directiveScope.removeAction = '&';
        directiveScope.editAction = '&';
        directiveScope.hideActions = '&';
        directiveScope.hideNextTask = '=';
        directiveScope.onResponsibilityUpdated = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller',
                function ($scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/BCM/BIAResponsibility/biaResponsibility.[Template].tpl.html';

                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'BCMManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'BIAProfile';

                    // Wait for link to calculate withActions
                    var unwatch = $scope.$watch('withActions', function (withActions) {
                        $scope.withActions = withActions && !$scope.hideActions();
                        unwatch();
                    });

                    $controller('BoxTmplController', { $scope: $scope });

                    // Is Impact Defined?
                    $scope.isImpactDefined = function (impact) {
                        return !_.isUndefined(impact);
                    };

                    // Format min MTPD for display
                    $scope.getMinMtpdDisplay = function (model) {
                        var expert = model.MtpdExpertValue;
                        var calc = model.MtpdCalculatedValue;
                        var val;
                        if (expert != null && calc != null) val = Math.min(expert, calc);
                        else if (expert != null) val = expert;
                        else if (calc != null) val = calc;
                        else return '';
                        var h = Math.floor(val / 60);
                        var m = val % 60;
                        if (h > 0 && m > 0) return h + 'h ' + m + 'm';
                        if (h > 0) return h + 'h';
                        return m + 'm';
                    };

                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                if (!_.isUndefined(attrs.removeAction)) scope.withActions = true;
                if (!_.isUndefined(attrs.editAction)) scope.withActions = true;
            }
        }
    }
})();
